import FullWidthImage from "./FullWidthImage";
import formatPrismicData from "../../hocs/formatPrismicData";

export default formatPrismicData(FullWidthImage);
